import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsRealtyCalendarBannerAvailable } from '../../../selectors/dailyRent';
import { useApplicationContext } from '../../ApplicationContext';
import { RealtyCalendarBanner } from './RealtyCalendarBanner';
import { trackRealtyCalendarBannerShow } from './tracking';

export const RealtyCalendarBannerContainer = () => {
  const { config } = useApplicationContext();

  const isBannerAvailable = useSelector(selectIsRealtyCalendarBannerAvailable);
  const helpUrl = config.get<string>('dailyRent.realtyCalendarHelpUrl');

  React.useEffect(() => {
    if (isBannerAvailable) {
      trackRealtyCalendarBannerShow();
    }
  }, [isBannerAvailable]);

  if (!isBannerAvailable) {
    return null;
  }

  return <RealtyCalendarBanner helpUrl={helpUrl!} />;
};

RealtyCalendarBannerContainer.displayName = 'RealtyCalendarBannerContainer';
